import React from "react";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography } from "@mui/material";
import { ownerApi } from "../../../../api/owner";
import { formatApiError } from "../../../../api/client";

function idOf(value) {
  return String(value?.id || value?._id || value || "");
}

export default function OwnerCommitmentTimeDialog({ open, commitment, requireOccurredAt = false, onClose, onSaved }) {
  const [minutes, setMinutes] = React.useState("");
  const [occurredAt, setOccurredAt] = React.useState("");
  const [note, setNote] = React.useState("");
  const [saving, setSaving] = React.useState(false);
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    if (!open) return;
    setMinutes("");
    setOccurredAt("");
    setNote("");
    setError("");
  }, [open, commitment, requireOccurredAt]);

  const submit = async () => {
    if (!idOf(commitment) || Number(minutes) <= 0) return;
    const when = occurredAt ? new Date(occurredAt) : null;
    if (requireOccurredAt && (!when || Number.isNaN(when.getTime()))) {
      setError("Indicá cuándo ocurrió ese trabajo real.");
      return;
    }
    setSaving(true);
    setError("");
    try {
      await ownerApi.addCommitmentTime(idOf(commitment), {
        minutes: Number(minutes),
        ...(when && !Number.isNaN(when.getTime()) ? { occurredAt: when.toISOString() } : {}),
        note,
        source: { kind: "manual" },
      });
      await onSaved?.();
      onClose?.();
    } catch (err) {
      setError(formatApiError(err, "No pude registrar el tiempo."));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} fullWidth maxWidth="xs">
      <DialogTitle>
        <Typography sx={{ fontWeight: 1000 }}>Tiempo real</Typography>
        <Typography sx={{ color: "text.secondary", fontSize: ".75rem" }}>{commitment?.title}</Typography>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={1.1} sx={{ pt: .7 }}>
          {requireOccurredAt ? (
            <TextField autoFocus required fullWidth type="datetime-local" InputLabelProps={{ shrink: true }} label="Cuándo trabajaste" value={occurredAt} onChange={(event) => setOccurredAt(event.target.value)} />
          ) : null}
          <TextField autoFocus={!requireOccurredAt} fullWidth type="number" inputProps={{ min: 1, step: 1 }} label="Minutos trabajados" value={minutes} onChange={(event) => setMinutes(event.target.value)} />
          <TextField fullWidth label="Qué hiciste (opcional)" value={note} onChange={(event) => setNote(event.target.value)} />
          {error ? <Alert severity="error">{error}</Alert> : null}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={saving} sx={{ textTransform: "none", fontWeight: 850 }}>Cancelar</Button>
        <Button variant="contained" disabled={saving || Number(minutes) <= 0 || (requireOccurredAt && !occurredAt)} onClick={submit} sx={{ textTransform: "none", fontWeight: 950 }}>
          {saving ? "Guardando…" : "Registrar tiempo"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
